import api, { API } from "@/lib/api";
import { whatsappHref, formatPrice } from "@/lib/settings";
import { toast } from "sonner";

/** Build the WhatsApp message body from a quote response and current selection */
export const buildWhatsAppMessage = ({ quote, tab, furniture, variation, width, height, depth, colorName, coverName, legName, handleName, currency }) => {
  return (
    `Merhaba, aşağıdaki ${quote.quote_no} numaralı teklife göre sipariş vermek istiyorum.\n\n` +
    `• Paket: ${tab === "professional" ? "Profesyonel" : "Standart"}\n` +
    `• Ürün: ${furniture.name}${variation ? " - " + variation : ""}\n` +
    `• Ölçüler: ${width}×${height}×${depth} cm\n` +
    `• Renk: ${colorName}\n` +
    `• Kapak: ${coverName}\n` +
    `• Ayak: ${legName} · Kulp: ${handleName}\n` +
    `• Tahmini Fiyat: ${formatPrice(quote.calc.total, currency)}\n\n` +
    `Teklif PDF'ini bu sohbete ekleyeceğim.`
  );
};

/** Triggers PDF download in a new tab using an <a> element (bypasses most popup blockers) */
export const downloadQuotePdf = (quote) => {
  const pdfUrl = `${API}/quotes/${quote.id}/pdf`;
  const a = document.createElement("a");
  a.href = pdfUrl;
  a.target = "_blank";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

/** Create a quote and only download the PDF (no WhatsApp) */
export const downloadOnlyQuote = async ({ payload }) => {
  const { data: quote } = await api.post("/quotes", payload);
  downloadQuotePdf(quote);
  toast.success(`Teklif indirildi: ${quote.quote_no}`);
  return quote;
};

/**
 * Create a quote, download the PDF, and open the WhatsApp deep-link.
 *
 * Pattern: open a blank window SYNCHRONOUSLY at the very start of the user
 * gesture so browsers don't block it. Fill it with the WhatsApp URL after
 * the async POST resolves. PDF opens via <a> click (no popup permission needed).
 */
export const submitQuote = async ({ payload, ctx, whatsappNumber }) => {
  // Pre-open a blank tab in the same user-gesture tick — required for
  // browsers that block popups initiated after `await`.
  const waWindow = typeof window !== "undefined" ? window.open("", "_blank") : null;

  try {
    const { data: quote } = await api.post("/quotes", payload);
    toast.success(`Teklif oluşturuldu: ${quote.quote_no}`);

    const msg = buildWhatsAppMessage({ quote, ...ctx });
    const waUrl = whatsappHref(whatsappNumber, msg);

    if (waWindow && !waWindow.closed) {
      waWindow.location.href = waUrl;
    } else {
      // Fallback if the pre-open was blocked: navigate current tab
      window.location.href = waUrl;
    }

    // Open PDF in a new tab via <a> click (bypasses popup blocker after await)
    downloadQuotePdf(quote);
    return quote;
  } catch (e) {
    if (waWindow && !waWindow.closed) waWindow.close();
    throw e;
  }
};
